import { initSubRoutes } from '../../../../utils/router';

const RoutesMunitions = initSubRoutes({
    route: '/munitions',
    subroutes: {},
    nom: 'Munitions',
});

export default RoutesMunitions;
